// =============================================================================
// FILE PATH: src/modules/pms/pages/ProjectDetailPage.js
// =============================================================================

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import ProjectDetail from "./ProjectDetail";
import GanttChart from "../components/GanttChart"; // 🔥 NEW IMPORT
import { getProjectDetail } from "../services/projectService";

import TaskMaterialPlanningPage
from "../task_material/TaskMaterialPlanningPage";

export default function ProjectDetailPage() {

  const { projectId } = useParams();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("WBS");
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(false);

  // ---------------------------------------------------------
  // LOAD PROJECT
  // ---------------------------------------------------------
  const loadProject = async () => {
    try {
      setLoading(true);
      const res = await getProjectDetail(projectId);
      setProject(res.data.data);
    } catch (err) {
      console.error("Error loading project", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (projectId) {
      loadProject();
    }
  }, [projectId]);

  return (
    <div style={styles.container}>

      {/* ================= HEADER ================= */}
      <div style={styles.header}>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <button
            style={styles.backBtn}
            onClick={() => navigate("/ipe/pms/projects")}
          >
            ← Back
          </button>

          <div>
            <h2 style={styles.title}>
              {project?.project_name || "Project Detail"}
            </h2>

            <div style={styles.subText}>
              {project?.customer_name || "-"} | {project?.order_no || "-"}
            </div>

            <div style={styles.subText}>
              Start: {project?.start_date || "-"} | Target: {project?.target_date || "-"}
            </div>

            <div style={styles.subText}>
              Status: {project?.status_code || "-"} | Progress: {project?.progress || 0}%
            </div>
          </div>
        </div>

      </div>

      {/* ================= TABS ================= */}
      <div style={styles.tabs}>

        {/* 🔥 UPDATED TAB LIST */}
        {["Overview", "WBS", "Gantt", "Materials", "Billing"].map(tab => (
          <div
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              ...styles.tab,
              ...(activeTab === tab ? styles.activeTab : {})
            }}
          >
            {tab}
          </div>
        ))}

      </div>

      {/* ================= CONTENT ================= */}
      <div style={styles.content}>

        {loading ? (
          <div style={styles.loader}>Loading...</div>
        ) : (
          <>
            {activeTab === "Overview" && (
              <div style={styles.overviewCard}>
                <div><b>Customer:</b> {project?.customer_name || "-"}</div>
                <div><b>Order:</b> {project?.order_no || "-"}</div>
                <div><b>Start Date:</b> {project?.start_date || "-"}</div>
                <div><b>Target Date:</b> {project?.target_date || "-"}</div>
                <div><b>Status:</b> {project?.status_code || "-"}</div>
                <div><b>Progress:</b> {project?.progress || 0}%</div>
              </div>
            )}

            {activeTab === "WBS" && (
              <ProjectDetail projectId={projectId} />
            )}

            {/* 🔥 NEW GANTT TAB */}
            {activeTab === "Gantt" && (
              <GanttChart projectId={projectId} />
            )}

            {activeTab === "Materials" && (
              <TaskMaterialPlanningPage
                projectId={projectId}
              />
            )}

            {activeTab === "Billing" && (
              <div>Billing module coming soon</div>
            )}
          </>
        )}

      </div>

    </div>
  );
}

// ==========================================================
// STYLES
// ==========================================================
const styles = {

  container: {
    padding: 20,
    background: "#f9fafb",
    minHeight: "100vh"
  },

  header: {
    marginBottom: 15
  },

  title: {
    margin: 0
  },

  subText: {
    fontSize: 12,
    color: "#6b7280"
  },

  backBtn: {
    padding: "6px 10px",
    background: "#e5e7eb",
    border: "none",
    borderRadius: 6,
    cursor: "pointer"
  },

  tabs: {
    display: "flex",
    gap: 10,
    marginBottom: 15,
    borderBottom: "1px solid #ddd"
  },

  tab: {
    padding: "8px 12px",
    cursor: "pointer"
  },

  activeTab: {
    borderBottom: "2px solid #4f46e5",
    fontWeight: "600"
  },

  content: {
    background: "#fff",
    borderRadius: 8,
    padding: 15,
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
  },

  loader: {
    padding: 20,
    textAlign: "center"
  },

  overviewCard: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    fontSize: 14
  }
};